export default __webpack_public_path__ + "static/media/clem-onojeghuo-2.91f87576.jpg";